import Input from './input'

export type { InputProps } from './input'

export { Input }
